import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { GenericService } from '../../services/generic.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  data: any[];

  constructor(
    private genericService: GenericService
  ) { }

  ngOnInit(): void {
    this.getData();
  }
  
  getData() {
    var params = new HttpParams()
      .set('whichUrl', 'Redes Sociais')
    this.genericService.getGenericMultiSearch(params).subscribe(result => {
      this.data = result;
    })
  }

  getRedeSocialLink(rede: string): string {
    return this.data?.find(x => x.Categoria == rede)?.link?.Url;
  }

}
